// Colors
const COLORS = {
  black: "#000000",
  white: "#ffffff",
  primaryBgColor: "#f4f4ea",
  secondaryTextColor: "#b4b4b4"
};

// Section Order
const SECTION_ORDER = [
  "hero",
  "about",
  "service",
  "banner",
  "keyPoint",
  "secondBanner",
  "map",
  "faq"
];

// Reusable Fields
const createImageField = () => ({ key: "", url: "", _id: "", asset: "" });
const createTextField = (color = COLORS.black) => ({ text: "", color });
const createButtonField = (bgColorDisplay = true) => ({
  bgColor: COLORS.black,
  bgColorDisplay
});
const createSwitchWithText = () => ({ text: "", switchEnabled: false });
const createArray = (length, factory) => Array.from({ length }, factory);
const createBgConfig = (color = COLORS.white, display = false) => ({
  bgColor: color,
  bgColorDisplay: display
});

// Base Section Structure
const createBaseSectionStructure = ({ component, name }) => ({
  isCustom: false,
  component,
  hashId: component,
  name
});

// Default Non-Custom Sections
const createHeroSection = () => ({
  ...createBaseSectionStructure({ component: "hero", name: "Hero" }),
  data: {
    ...createBgConfig(),
    image: createImageField(),
    youtubeVideoSwitchEnabled: false,
    youtubeVideoLink: "",
    btn: createButtonField()
  }
});
const createAboutSection = () => ({
  ...createBaseSectionStructure({ component: "about", name: "About" }),
  data: {
    images: [createImageField(), createImageField(), createImageField()],
    mobileSortDirection: false,
    ...createBgConfig()
  }
});
const createServiceSection = () => ({
  ...createBaseSectionStructure({ component: "service", name: "Service" }),
  data: {
    ...createBgConfig(),
    services: createArray(3, () => ({
      heading: createTextField(),
      para: createTextField(),
      image: createImageField()
    }))
  }
});
const createBannerSection = () => ({
  ...createBaseSectionStructure({ component: "banner", name: "Banner" }),
  data: {
    heading: createTextField(COLORS.white),
    para: createTextField(COLORS.white),
    btn: { color: COLORS.white, ...createButtonField(false) },
    image: createImageField()
  }
});
const createKeyPointSection = () => ({
  ...createBaseSectionStructure({ component: "keyPoint", name: "Key Point" }),
  data: {
    ...createBgConfig(),
    keyPoints: createArray(4, () => ({
      heading: createTextField(),
      para: createTextField()
    }))
  }
});
const createSecondBannerSection = () => ({
  ...createBaseSectionStructure({
    component: "secondBanner",
    name: "Second Banner"
  }),
  data: {
    ...createBgConfig(COLORS.primaryBgColor, true),
    btn: createButtonField(),
    image: createImageField()
  }
});
const createMapSection = () => ({
  ...createBaseSectionStructure({ component: "map", name: "Map" })
});
const createFaqSection = () => ({
  ...createBaseSectionStructure({ component: "faq", name: "Faqs" }),
  data: {
    ...createBgConfig(COLORS.primaryBgColor, true),
    active: false,
    faqs: { data: [{ q: "", a: "" }] }
  }
});

export const getDefaultWebsiteEditorValues = (initialValues, t) => ({
  language: "de",
  brand_colors: {
    logo_color: COLORS.black,
    heading_dark: COLORS.black,
    heading_light: COLORS.white,
    text_primary: COLORS.black,
    text_secondary: COLORS.secondaryTextColor,
    text_light: COLORS.white,
    btn_primary: COLORS.white,
    btn_bg_primary: COLORS.black,
    btn_secondary: COLORS.white,
    btn_bg_secondary: COLORS.black,
    primary_bg: COLORS.primaryBgColor,
    secondary_bg: COLORS.white
  },
  favIcon: undefined,
  navbar: {
    ...createBgConfig(),
    logo: { color: COLORS.black },
    secondPhone: createSwitchWithText(),
    secondAddress: createSwitchWithText()
  },
  sections: SECTION_ORDER.map((key) => initialValues[key]),
  footer: {
    ...createBgConfig(),
    logo: { color: COLORS.black },
    footer_links: {
      social_link: { text: t("customerWebsite.socialLinks") },
      quick_links: { text: t("customerWebsite.quickLinks") },
      pp_links: {
        text: t("customerWebsite.policies"),
        showAsPages: false,
        links: [{ text: "Datenschutz" }, { text: "Impressum" }]
      }
    },
    contact_card: {
      text: t("customerWebsite.contact"),
      btn: createButtonField()
    },
    local_seo_links: { color: "#888888" },
    showAMCreditBanner: true
  }
});

export const getInitialWebsiteEditorValues = () => ({
  hero: createHeroSection(),
  about: createAboutSection(),
  service: createServiceSection(),
  banner: createBannerSection(),
  keyPoint: createKeyPointSection(),
  secondBanner: createSecondBannerSection(),
  map: createMapSection(),
  faq: createFaqSection()
});
